<template>
    <!-- class="w-100 vh-100 overflow-hidden"  -->
    <section id="training">

        <!-- Start Training Component -->
        <Training />
        <!-- End Training Component -->

        <!-- Start Footer Component -->
        <Footer />
        <!-- End Footer Component -->

    </section>
</template>

<script>

import Training from '@/components/service/Training.vue';

export default {

    name: 'TrainingView',

    components: {
        Training,
    },

    data() {
        return {
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth,
        }
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
            if (this.windowHeight < 895) {
                document.getElementById('training').style.height = "100%";
                document.querySelector('footer').style = 'position: initial';
            }
        })
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },

    methods: {
        onResize() {
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
            if (this.windowHeight < 895) {
                document.getElementById('training').style.height = "100%";
                document.querySelector('footer').style = 'position: initial'
            }
        }
    }
}
</script>

<style scoped lang="scss">
#training {

    width: 100%;
    height: 100vh;
    overflow: hidden;

    @include breakpoints(x-small) {
        height: 100%;
        overflow: visible;
    }

    @include breakpoints(small) {
        height: 100%;
        overflow: visible;
    }

    @include breakpoints(medium) {
        height: 100%;
        overflow: visible;
    }

    // https://www.w3schools.com/cssref/pr_background-image.php
    /* The image used */
    background-image: url("@/assets/images/about/about_BG.webp");
    /* Used if the image is unavailable */
    // background-color: $Gray;
    /* Center the image */
    background-position: center;
    /* Do not repeat the image */
    background-repeat: no-repeat;
    /* Resize the background image to cover the entire container */
    background-size: cover;

    footer {
        @include breakpoints(x-small) {
            position: initial;
        }

        @include breakpoints(small) {
            position: initial;
        }

        @include breakpoints(medium) {
            position: initial;
        }
    }

}
</style>